import React from "react";
import { EmailMessageTable } from "./EmailMessageTable/EmailMessageTable";

function EmailMessageManagement(){
    return <EmailMessageTable />
}

export { EmailMessageManagement }